module.exports = __webpack_public_path__ + "c_static/img/3-4电脑京东购物车.2f5cead.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/3-4电脑京东购物车.jpg
// module id = EMe4
// module chunks = 33